const categorizeRates = (rates, balances) => {
  const { availableLpBalance, pointExcMerchantBal } = balances;

  return rates.reduce(
    (groups, rate) => {
      const isLP = rate.sourceCode === 'LP';
      const isDisabled = isLP
        ? Number(rate.source) > Number(availableLpBalance)
        : Number(rate.source) > Number(pointExcMerchantBal);

      const groupKey = isLP ? 'out' : 'in';

      return {
        ...groups,
        [groupKey]: [...groups[groupKey], { ...rate, disabled: isDisabled }],
      };
    },
    { out: [], in: [] },
  );
};

export default categorizeRates;
